<template>
  <div class="page">
    <van-nav-bar :title="$t('concubine.concubine')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="box">
      <p class="name">{{ this.xuanfeidata.xuanfei_name }}</p>
      <div class="view">
        <div class="detail-tabs active"><img src="/img/ico/ico-info.31a6afcb.png" alt="" class="detail-tabs-ico"> info
        </div>
        <div class="detail-tabs"><img src="/img/ico/ico-img-active.fc388b3a.png" alt="" class="detail-tabs-ico"> images
          ({{ this.xuanfeidata.img_url.length }})
        </div>
        <div class="detail-tabs"><img src="/img/ico/ico-notice-active.18e68919.png" alt="" class="detail-tabs-ico">
          reprot (20)
        </div>
      </div>
      <p class="title">{{ this.xuanfeidata.vo_title }}</p>
      <van-image width="98%" fit="contain" height="100%" v-for="(v, k) in xuanfeidata.img_url" :key="k" :src="v" />
      <van-button round="true" @click="yuyue" class="button"
        color="linear-gradient(to right, #775fd9,#c24491)">{{$t("foorter.subscribe")}}</van-button>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        xuanfeidata: []
      };
    },
    methods: {
      back() {
        this.$router.push({
          path: 'list?id=' + this.$route.query.adsid + '&name=' + this.$route.query.name
        });
      },
      getxuanfeidata() {
        this.$http({
          method: 'get',
          url: 'xuanfeidata',
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.xuanfeidata = res.data;
        });
      },
      yuyue() {
        this.$http({
          method: 'post',
          url: 'yuefei',
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.$toast(res.msg);
          setTimeout(() => {
            if(res.code == 200){
              this.$router.push({
                path: '/Choose'
              });
            }
          }, 3000);
        });
      }
    },
    created() {
      this.getxuanfeidata();
    }
  };
</script>

<style>
  .container {
    display: inline-block;
  }

  .box {
    width: 95%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 6.25rem;
  }

  .title {
    font-size: 0.625rem;
  }

  .button {
    width: 10rem;
    height: 2.5rem;
    font-size: 0.9375rem;
    margin-top: 0.625rem;
  }

  .view {
    display: flex;
    white-space: nowrap;
  }

  .view img {
    width: 30px;
  }

  .detail-tabs.active {
    color: #f905e5;
  }

  .detail-tabs {
    color: #e74c3c;
    font-size: 4vw;
    flex: 1;
    padding: 5.333vw 2.667vw;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .detail-tabs-ico {
    width: 30px;
    margin-right: 6px;
  }

  .movie-list-n-item-bottom {
    width: 90%;
    text-align: left;
  }

  .movie-n-time-div {
    margin-top: 20px;
  }

  .movie-n-time-div img {
    width: 30px;
  }

  .movie-list-notice,
  .movie-list-addr,
  .movie-list-money {
    display: flex;
    align-items: center;
    padding: 5px 0;
  }

  .table-title {
    padding: 30px;
    font-size: 36px;
    background: #ccc;
    border-bottom: 1px solid #eee;
    text-align: left;
  }
  
  .table {
    color: #000;
  }

  .table .table-list:nth-child(2n) {
    background: #999;
  }

  .table .table-list {
    padding: 2.667vw 4vw;
    display: flex;
    background: #eee;
  }
  
  .table .name{
    width: 30%;
    text-align: left;
  }
</style>